import { styled } from '@mui/system';

export const SidebarStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  width: '56px',
  height: '100%',
  padding: '0 8px 16px',
  backgroundColor: 'var(--color-sidebar-bg)',

  '.logo-container': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    margin: '12px 0 24px 0',
    borderRadius: 'var(--radius-lg)',
    background: 'var(--gradient-primary)',
    flexShrink: 0,
  },

  '.logo': {
    width: '24px',
    height: '24px',
  },

  '.sidebar-items-list': {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  '.sidebar-bottom-section': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderTop: '1px solid rgba(255,255,255,0.15)',
    paddingTop: '8px',
  },
});
